document.addEventListener('click', (e) => {
        const variantBtn = e.target.closest('.complete-look__variant');
        if (!variantBtn) return;

        const container = variantBtn.closest('.complete-look__item');

        // active state
        container.querySelectorAll('.complete-look__variant')
          .forEach(btn => btn.removeAttribute('data-active'));

        variantBtn.setAttribute('data-active', '');

        const variantId = variantBtn.dataset.variantId;
        const value = variantBtn.dataset.value;

        // update add to cart
        const addBtn = container.querySelector('[data-add-to-cart]');
        addBtn.dataset.variantId = variantId;

        // update label
        const label = container.querySelector('[data-variant-label]');
        if (label) label.textContent = value;
      });